import React, { useState } from "react";
import "./home.css";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { FormulaireStep1 } from "modules/resiliation/ui/components/formulaire-step1";
import { Resiliation } from "modules/resiliation/model/resiliation";
import ProgressBar from "shared/components/progress-bar/progress-bar";

import PopUpStart from "shared/components/popUpStart/popUpStart";
import AvatarWithBadge from "shared/components/avatar-with-badge/avatar-with-badge";
import { Formulaire } from "pages/formulaire/formulaire";
import { RootState } from "config/reducers";
import { useSelector } from "react-redux";
import { TypeStep } from "modules/resiliation/store/resiliation.slice";
import { isMobile } from 'react-device-detect';

export const Home = () => {
  const navigate = useNavigate();
  const submit = (resiliation: Resiliation) => {
    // dispatch(majReclamation(reclamation));
  };
  const [showpopup, setShowpop] = useState(true);

  const closePopup = () => {
  
    setShowpop(false);
  };

  //const [step, setStep] = React.useState(1);
  let step = useSelector((state: RootState) => state.resiliation.step);
  const steps: any = {
    1: { title: "Etape 1 : Identité de l'adhérent ", progress: 30 },
    2: { title: "Etape 2 : Identification du contrat ", progress: 50 },
    3: { title: "Etape 3 : Motif de la demande ", progress: 70 },
    4: { title: "Etape 3 : Motif de la demande ", progress: 70 },

  };

  const getTitleByStep = (step: number) => {
    switch (step) {
      case 0:
        return [
          "Bonjour, je vais vous accompagner pour compléter votre demande. Pouvez-vous me rappeler vos informations personnelles ?",
        ];
      case 1:
        return ["De quelle adhésion s’agit-il ?"];
      case 2:
        return ["Que souhaitez vous faire ?"];
      case 3:
        return ["Veuillez indiquer le motif de votre demande ?"];
      default:
        return [
          "Bonjour, je vais vous accompagner pour compléter votre demande. Pouvez vous me rappeler vos informations personnelles ?",
        ];
    }
  };

  const title = getTitleByStep(step);

  const avatar: any = require("../../assets/justine.png");

  return (
    isMobile ?
      <div>
        {/* <Container fixed sx={{ maxHeight: "500px", maxWidth: "600px" }}> */}
          <Box sx={{ bgcolor: "#fff" }}>
            {step !== TypeStep.recap ? (
              <div className="avatar-style-mobile">
                <AvatarWithBadge
                  hideButton={false}
                  avatar={avatar}
                  title={title}
                  text={title}
                />
              </div>
            ) : (
              ""
            )}
            {step !== TypeStep.recap ? (
              <ProgressBar className="progress-bar-mobile" step={steps[step + 1]} />
            ) : (
              ""
            )}
            <Formulaire />
          </Box>
        {/* </Container> */}

        <div>
          {showpopup ? <PopUpStart closePopup={closePopup} /> : <div></div>}
        </div>
      </div>
      :
      <div>
        <Container fixed style={{marginBottom:'3rem'}}>
          <Box sx={{ bgcolor: "#fff",  marginLeft: "30px" }}>
            {step !== TypeStep.recap ? (
              <div className="avatar-style">
                <AvatarWithBadge
                  hideButton={false}
                  avatar={avatar}
                  title={title}
                  text={title}
                />
              </div>
            ) : (
              ""
            )}
            {step !== TypeStep.recap ? (
              <ProgressBar className="progress-bar" step={steps[step + 1]} />
            ) : (
              ""
            )}
            <Formulaire />
          </Box>
        </Container>

        <div>
          {showpopup ? <PopUpStart closePopup={closePopup} /> : <div></div>}
        </div>
      </div>
  );
};
export default Home;
